import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "../scss/intro.scss";

export default function Intro() {
  // Switch theme
  const htmTag = document.getElementsByTagName("html")[0];
  const switchMood = (event) => {
    event.preventDefault();

    htmTag.classList.toggle("dark-theme");
  };

  return (
    <div id="intro">
      <Helmet>
        <title>charlie-gp | Smash that Intro!</title>
      </Helmet>

      <div id="avatar">
        <div>
          <img src="/images/avatar.jpg" height="144" width="144" alt="Avatar" />
        </div>
      </div>
      <div id="menu">
        <div>
          <ul>
            <li>
              <a
                href="https://www.linkedin.com/in/charlie-g-pandacan"
                title="My LinkedIn"
              >
                <i className="bi-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="https://github.com/gitChang" title="My Github">
                <i className="bi-github"></i>
              </a>
            </li>
            <li>
              <a
                href="https://stackoverflow.com/users/2612959/charlie"
                title="My StackoverFlow"
              >
                <i className="bi-stack-overflow"></i>
              </a>
            </li>
            <li>
              <a href="mailto:charliepandacan@gmail.com" title="Mail me">
                <i className="bi-envelope-plus"></i>
              </a>
            </li>
            <li>
              <Link to="/blog/" title="Read a blog">
                <small className="fw-bold">Blog</small>
              </Link>
            </li>
            <li>
              <a href="/" onClick={switchMood} title="Switch Mood">
                <i className="bi-circle-half"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <h2 id="hi">Smash that Intro!</h2>
      <img
        className="mt-4 mb-4"
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Jonathan_Davis_%2855209606%29.jpeg/330px-Jonathan_Davis_%2855209606%29.jpeg"
        style={{ height: "230px", width: "100%", objectFit: "cover" }}
        alt="Jonathan Davis"
      />

      <br />
      <p className="h5">Introduction</p>
      <p>
        Hi, I'm Charlie a full-stack engineer from Philippines. Thank you for
        dropping by! I love desktop customization, tweaking, and learning new
        technologies on the Web. In case of power loss, I'll just ride my bike
        for pass time and be in the nature.
      </p>
      <br />
      <p className="h5">Credits</p>
      <p>
        First of all, I would like to thank these guys for such a wonderful
        journey: <br />
        <a href="https://www.w3schools.com/cpp/cpp_intro.asp">C++</a>,{" "}
        <a href="https://en.wikipedia.org/wiki/Assembly_language">Assembly</a>,{" "}
        <a href="https://www.vbtutor.net/vbtutor.html">Visual Basic 6</a>,{" "}
        <a href="http://www.oldversion.com/windows/macromedia-flash-8-0">
          Macromedia Flash 8
        </a>
        ,{" "}
        <a href="https://adobe-photoshop-cs2.fileplanet.com/">Photoshop CS2</a>,{" "}
        <a href="https://ubuntu.com/">Ubuntu 7</a>,{" "}
        <a href="https://www.coreldraw.com/en/pages/coreldraw-x3/">
          Corel Draw X3
        </a>
        , and{" "}
        <a href="https://www.softlay.com/downloads/windows-xp-sp3">
          Windows XP Service Pack 3
        </a>
        ! The version will tell, you guys are a legend.
      </p>
      <br />
      <p>
        Back then, there was a professor with a patience level of 99.9 percent,
        he was different compared to others. He wanted us to catch up, to learn,
        to create, and someday, be a Software Engineer. That was the first time
        I heared the title and it's a Goosebumps.
      </p>
      <p>
        Thanks to{" "}
        <a href="https://www.linkedin.com/in/ariel-gamao-1b8258152">you</a>,
        Sir. We did learn CS stuff, and now, here we are, toying things on the
        internet.
      </p>
      <br />
      <p className="h5">A Good Experience</p>
      <p>
        Okay, my first job experience was a{" "}
        <a href="https://www.microsoft.com/en-ie/download/details.aspx?id=23206">
          VB.Net
        </a>{" "}
        Developer. The goal was to modernize the systems both Inventory and
        Accounts Receivable System. The challenge were data Extraction and data
        migration. The good thing is, my former{" "}
        <a href="https://web.facebook.com/profile.php?id=100009254257224">
          colleague
        </a>{" "}
        had already did the extraction. She found a way to read the database
        file. Fortunately, we were able to managed the data migration into{" "}
        <a href="https://www.oreilly.com/library/view/learning-sql-on/0596102151/ch01.html">
          Microsoft SQL Server 2005
        </a>
        .
        <br />
      </p>
      <br />
      <p className="h5">Goals and Frustrations</p>
      <p>
        Currently, I am developing new skills to catch up. I chose{" "}
        <a href="https://www.atlassian.com/devops/what-is-devops/devops-engineer">
          DevOps Engineer
        </a>{" "}
        or{" "}
        <a href="https://www.techtarget.com/searchcloudcomputing/definition/cloud-engineer">
          Cloud Engineer
        </a>{" "}
        'cause I think that would be stimulating and I really like
        configurations. However, acquiring hands-on experience with these
        technologies is so frustrating. Like, you can have your Free Tier,
        provided that payment method is secured. <strong>Oh, come on!</strong>
      </p>
      <p>
        The bottom line here is, there will be always a new set of tools will
        come along the way. But your foundation, fundamentals, experience, and
        logic are what really matters at the end of the day.
      </p>
      <br />
      <ul id="find-me">
        <li>
          Find me on{" "}
          <a href="https://www.linkedin.com/in/charlie-g-pandacan">LinkedIn</a>,
        </li>
        <li>
          <a href="https://github.com/gitChang">GitHub</a>,
        </li>
        <li>
          <a href="https://stackoverflow.com/users/2612959/charlie">
            StackoverFlow
          </a>
          ,
        </li>
        <li>
          <a href="https://www.deviantart.com/whchaz1027i">DeviantArt</a>.
        </li>
      </ul>
      <p className="mb-0">
        Mail me at <a href="mailto:charliepandacan@gmail.com">GMail</a>.
      </p>
      <p className="text-end">
        <a href="#root">
          <i className="bi-arrow-up"></i> Back to top
        </a>
      </p>
    </div>
  );
}
